// components/ui/headers/title-button.js
import { Stack, Button, SvgIcon, Typography } from '@mui/material';
import AddIcon from 'src/icons/untitled-ui/free/push';

const TitleButton = ({
  label,
  onButtonClick,
  disableButton = false,
  name = 'Thêm',
  icon: Icon = AddIcon,
  extraContent, // New prop to accept dynamic content
  sx = { width: 200 },
}) => (
  <Stack direction="row" justifyContent="space-between" spacing={1}>
    <Stack direction="row" justifyContent="space-between" sx={{ py: 0.5 }}>
      <Typography
        color="text.primary"
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          fontSize: {
            xs: '1rem', 
            sm: '1.1rem'
          },
          fontWeight: 500,
          lineHeight: 1.5,
        }}
      >
        {label}
      </Typography>
    </Stack>
    <Stack alignItems="center" direction="row" sx={{ py: 0.5 }}>
      {extraContent && (
        <Stack sx={{ ...sx }}>
          {extraContent} {/* Apply dynamic styles to extraContent */}
        </Stack>
      )}
      {onButtonClick && ( // Render the button only if onButtonClick exists
        <Button
          startIcon={
            <SvgIcon
              sx={{
                fontSize: { xs: 16, sm: 24 },
              }}>
              <Icon />
            </SvgIcon>
          }
          variant="contained"
          onClick={ onButtonClick }
          disabled={ disableButton }
          sx={{
            px: { xs: 1.25, sm: 1.75 },
            fontSize: { xs: '0.85rem', sm: '0.875rem' },
            height: { xs: 36, sm: 'auto' },
            '& .MuiButton-startIcon': {
              mr: { xs: 0.5, sm: 0.5 },
            },
          }}
        >
          {name}
        </Button>
      )}
    </Stack>
  </Stack>
);

export default TitleButton;

/**
 * import SaveIcon from '@mui/icons-material/Save';
 * <TitleButton label={t(...)} onButtonClick={<function>} name={t(...)} icon={SaveIcon} />
 */
